
export default function Title (props)
{
    return (<div className="text-center text-uppercase fs-3 m-3">{props.children}</div>);
}
